import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";

import { CreateOrganizationNamespace } from "../constants";

import type { Organization, APIObject } from "@packages/client";
import type { AsyncThunkOptionType } from "Reducers/types";

export const createOrganization = createAsyncThunk<
  Organization,
  { organization: APIObject; redirectTo?: boolean },
  AsyncThunkOptionType
>(
  "app/organizations/create_organization",
  async ({ organization }, { rejectWithValue }) => {
    try {
      const platformLib = await import("Libs/platform");
      const client = platformLib.default;

      const newOrganizationReference =
        await client.createOrganization(organization);

      const newOrganization: Organization =
        await newOrganizationReference.getEntity();

      return newOrganization;
    } catch (err) {
      logger(err, {
        action: CreateOrganizationNamespace,
        organization
      });

      return rejectWithValue(typeof err === "string" ? JSON.parse(err) : err);
    }
  }
);
